import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const ssoGuard: CanActivateFn = (route, state) => {
  const oauthService = inject(OAuthService);
  const hasAccessToken = oauthService.hasValidAccessToken();

  if (!hasAccessToken) {
    console.warn(
      `No valid access token to navigate to the destination : ${state.url}`,
    );
    return false;
  }

  return true;
};
